// extracted by mini-css-extract-plugin
module.exports = {"mobileSocialLink":"SocialLink__mobileSocialLink--2OizP","icon":"SocialLink__icon--2dHUQ","noPointer":"SocialLink__noPointer--gHKYo","bounce":"SocialLink__bounce--nDAqQ"};